export default {
    emailEditor: {
        tabs: {
            add: "Adicionar",
            settings: "Configurações",
            blocks: "Blocos",
            modules: "Módulos",
            layout: "Layout",
        },
        add: {
            sections: "Seções",
            rows: "Linhas",
            showMore: "Ver mais",
            showLess: "Ver menos",
        },
        defaults: {
            imageAlt: "Imagem",
            textContent: "Seu texto aqui...",
        },
        topbar: {
            undo: "Desfazer",
            redo: "Refazer",
            clearSelection: "Limpar seleção",
            preview: "Pré-visualizar",
            backToEditor: "Voltar ao editor",
            copyHtml: "Copiar HTML",
            templateGallery: "Galeria de templates",
            saveAsTemplate: "Salvar como template",
            close: "Fechar",
            save: "Salvar",
            settings: "Configurações",
            emailSettings: "Configurações do email",
        },
        templateGallery: {
            title: "Galeria de templates",
            subtitle: "Escolha um template para começar a editar.",
            loading: "Carregando...",
            noScreenshot: "Sem screenshot",
            blankModel: "Modelo vazio",
            place: "Do estabelecimento",
            global: "Global",
            close: "Fechar",
            startBlank: "Começar em branco",
        },
        saveAsset: {
            editTitle: "Editar {0}",
            saveAsTitle: "Salvar como {0}",
            editSubtitle: "Atualize nome/visibilidade.",
            createSubtitle: "De um nome e escolha a visibilidade.",
            name: "Nome",
            namePlaceholder: "Ex.: Promocao de Verao",
            visibility: "Visibilidade",
            placeVisibility: "Visivel somente para este estabelecimento",
            globalVisibility: "Visivel para todos",
            placeHint: "Visivel somente para este estabelecimento.",
            delete: "Excluir",
            cancel: "Cancelar",
            save: "Salvar",
            saving: "Salvando…",
            kindModule: "modulo",
            kindTemplate: "template",
        },
        ai: {
            badge: "Kevi IA",
            hint: "Descreva o que voce quer mudar no email. Use Enter para novas linhas. Enviar: Ctrl+Enter / Cmd+Enter.",
            placeholder: "Ex.: Troque o titulo para 'Promocao de Verao', deixe o botao verde e mova o bloco de imagem para cima.",
            ariaLabel: "Editar email com IA",
            apply: "Aplicar com IA",
            applying: "Aplicando…",
            loadingAria: "Gerando com IA",
            loadingSubtitle: "Isso pode levar ate 1 minuto.",
            loadingSentenceAnalyze: "Analisando seu pedido…",
            loadingSentenceStructure: "Entendendo a estrutura do email…",
            loadingSentenceApply: "Aplicando alteracoes no layout…",
            loadingSentenceAdjust: "Ajustando estilos e espacamentos…",
            loadingSentenceReview: "Revisando o JSON final…",
            loadingFallback: "Gerando alteracoes…",
        },
        modules: {
            loading: "Carregando modulos...",
            empty: "Nenhum modulo disponivel.",
        },
        mobile: {
            insertHere: "Inserir aqui",
            moveRowHere: "Mover linha para ca",
            moveSectionHere: "Mover secao para ca",
            moveColumnHere: "Mover coluna para ca",
            moveBlockHere: "Mover bloco para ca",
        },
        titles: {
            block: "Bloco: {type}",
            rowSettings: "Configurações da linha",
            columnSettings: "Configurações da coluna",
            containerSettings: "Configurações do container",
            sectionTag: "(seção)",
            emailDesign: "Design do e-mail",
        },
        common: {
            align: "Alinhamento",
            top: "Topo",
            middle: "Meio",
            bottom: "Base",
            left: "Esquerda",
            center: "Centro",
            right: "Direita",
            axisY: "Y",
            axisX: "X",
            unitPercent: "%",
            unitPx: "px",
            width: "Largura",
            widthAuto: "Automática",
            widthFilled: "Preenchida",
            text: "Texto",
            link: "Link",
            linkOptional: "Link (opcional)",
            background: "Fundo",
            color: "Cor",
            thickness: "Espessura",
            heightPx: "Altura (px)",
            widthPx: "Largura (px)",
            padding: "Padding",
            margin: "Espaço externo",
            radius: "Arredondamento",
            borderRadiusSquare: "Quadrada",
            borderRadiusSmall: "Pequeno (4px)",
            borderRadiusMedium: "Médio (8px)",
            borderRadiusLarge: "Grande (16px)",
            borderRadiusXLarge: "Muito grande (32px)",
            borderRadiusCircle: "Círculo",
            paddingHorizontal: "Padding horizontal",
            paddingVertical: "Padding vertical",
            corners: "Cantos",
            display: "Exibição",
            displayBlock: "Em bloco",
            displayInline: "Em linha",
            urlPlaceholder: "https://...",
        },
        borderSettings: {
            label: "Borda",
            color: "Cor da borda",
            enabled: "Ativado",
            disabled: "Desativado",
            sides: "Lados",
            width: "Espessura",
            style: "Estilo",
        },
        image: {
            url: "URL da imagem",
            alt: "Texto alternativo",
            chooseFile: "Escolher arquivo",
            display: "Exibição",
            displayBlock: "Em bloco",
            displayInline: "Em linha",
            widthPx: "Largura (px)",
            borderRadiusPx: "Arredondamento",
            objectFit: "Ajuste da imagem",
            objectFitCover: "Cobrir (cover)",
            objectFitContain: "Conter (contain)",
            objectFitFill: "Preencher (fill)",
            objectFitNone: "Nenhum (none)",
            objectFitScaleDown: "Reduzir (scale-down)",
            aspectRatio: "Proporção (aspect ratio)",
            aspectRatioAuto: "Automático",
            aspectRatioSquare: "Quadrado (1:1)",
            aspectRatio16x9: "Widescreen (16:9)",
            aspectRatio9x16: "Vertical (9:16)",
            aspectRatio4x3: "Padrão (4:3)",
            aspectRatio3x4: "Retrato (3:4)",
            aspectRatio3x2: "Foto (3:2)",
            aspectRatio2x3: "Retrato (2:3)",
        },
        margins: {
            title: "Espaços",
            topPx: "Superior (px)",
            bottomPx: "Inferior (px)",
            leftPx: "Esquerda (px)",
            rightPx: "Direita (px)",
            defaults: "Padrão: superior 8px, esquerda/direita 0px.",
        },
        row: {
            columns: "Colunas",
            columnSingular: "coluna",
            columnPlural: "colunas",
            align: "Alinhamento da linha",
            mobileOrientation: {
                label: "Orientação do conteúdo no mobile",
                leftOnTop: "Esquerda em cima",
                rightOnTop: "Direita em cima",
                keepColumns: "Manter colunas",
            },
            mobileOrientationLeftOnTop: "Esquerda em cima",
            mobileOrientationRightOnTop: "Direita em cima",
            mobileOrientationKeepColumns: "Manter colunas",
            paddingTop: "Padding superior",
            paddingBottom: "Padding inferior",
            paddingLeft: "Padding esquerda",
            paddingRight: "Padding direita",
            columnGap: "Espaço entre colunas",
            background: "Fundo da linha",
            backgroundHelp: "Defina como branco para simular faixas separadas.",
            marginHelp: "Espaço fora da borda da linha. Use para afastar uma linha com borda da borda do e-mail.",
        },
        button: {
            canvasHint: "Dica: você pode editar e formatar direto no botão (no canvas).",
        },
        column: {
            controls: "Controles da coluna",
            verticalAlignLabel: "Alinhamento vertical",
            verticalAlignHelp:
                "Controla o alinhamento vertical do conteúdo dentro da coluna.",
            backgroundHelp:
                "Aplicado só dentro desta coluna (não afeta as outras colunas da linha).",
        },
        emailDesign: {
            background: "Fundo",
            body: "Fundo do conteúdo",
            emailWidthLabel: "Largura do e-mail",
            widthPx: "Largura (px)",
            topSpacingPx: "Espaço superior (px)",
            borderRadiusPx: "Arredondamento",
            mobilePaddingPx: "Padding no mobile (px)",
            fontFamily: "Família da fonte",
            fontHelveticaArial: "Helvetica / Arial",
            fontArial: "Arial",
            fontVerdana: "Verdana",
            fontTahoma: "Tahoma",
            fontTrebuchetMs: "Trebuchet MS",
            fontGeorgia: "Georgia",
            fontTimesNewRoman: "Times New Roman",
            fontCourierNew: "Courier New",
            text: "Texto",
            links: "Links",
            buttonBackground: "Fundo do botão",
            buttonText: "Texto do botão",
        },
        actions: {
            deleteBlock: "Excluir bloco",
            deleteRow: "Excluir linha",
            deleteContainer: "Excluir container",
            duplicateColumn: "Duplicar coluna",
        },
        settingsTabs: {
            block: "Bloco",
            column: "Coluna",
            row: "Linha",
            section: "Seção",
        },
        settingsEmpty: {
            block: "Selecione um bloco para editar.",
            column: "Selecione uma coluna para editar.",
            row: "Selecione uma linha para editar.",
            section: "Selecione uma seção para editar.",
        },
        backgroundPicker: {
            color: "Cor",
            image: "Imagem",
            choose: "Escolher imagem",
            remove: "Remover",
            empty: "Sem imagem",
            size: "Tamanho",
            sizeCover: "Cover",
            sizeContain: "Contain",
            sizeCustomWidth: "Personalizado (largura)",
            repeat: "Repetição",
            repeatNoRepeat: "Não repetir",
            repeatRepeat: "Repetir",
            repeatRepeatX: "Repetir X",
            repeatRepeatY: "Repetir Y",
            position: "Posição",
            positionLeftTop: "Esquerda / Topo",
            positionCenterTop: "Centro / Topo",
            positionRightTop: "Direita / Topo",
            positionLeftCenter: "Esquerda / Centro",
            positionCenterCenter: "Centro",
            positionRightCenter: "Direita / Centro",
            positionLeftBottom: "Esquerda / Baixo",
            positionCenterBottom: "Centro / Baixo",
            positionRightBottom: "Direita / Baixo",
        },
        mobileInsertBar: {
            add: "Adicionar",
            chooseOther: "Escolher outro elemento",
            cancelInsertion: "Cancelar inserção",
            insertContent: "Inserir conteúdo",
            mode: "Modo",
            close: "Fechar",
            selectMode: "Selecionar modo",
            cancel: "Cancelar",
            elements: "Elementos",
            row: "Linha {0}",
            loading: "Carregando…",
            noModules: "Nenhum módulo",
            module: "Módulo",
            noPreview: "Sem preview",
        },
        mobileActionMenu: {
            title: "Ações",
            editSettings: "Editar configurações",
        },
        preview: {
            device: "Dispositivo de visualização",
            desktop: "Desktop",
            mobile: "Mobile",
        },
        emptyState: {
            dragBlocksHere: "Arraste blocos aqui",
            dragModulesOrLayoutsHere: "Arraste módulos ou layouts aqui",
        },
        container: {
            name: "Nome da seção",
            add: "Adicionar seção",
            controls: "Controles do container",
            personalizationTitle: "Personalização",
            personalizationCreditTooltip:
                "Será consumido 1 crédito extra para cada email enviado.",
            personalizationCreditAmount: "1 crédito",
            personalizationDescription:
                "Descreva como a Kevi IA deve adaptar essa seção para cada cliente.",
            backgroundHelp:
                "Dica: use seções para separar cabeçalho, corpo e rodapé com fundos e paddings diferentes.",
            containerSettings: "Configurações da seção",
            contentAreaSettings: "Configurações da área de conteúdo",
            border: "Borda da seção",
            contentBackground: "Fundo",
            bodyBackground: "Fundo do conteúdo",
            contentBorder: "Borda",
            contentBorderRadius: "Cantos",
            paddingHelp: "Espaço ao redor do card de conteúdo na faixa de largura total. Não afasta as linhas dentro do card.",
        },
        tooltips: {
            dragRow: "Arrastar linha",
            dragBlock: "Arrastar bloco",
            drag: "Drag",
            duplicate: "Duplicar",
            delete: "Excluir",
            edit: "Editar",
            settings: "Configuracoes",
            move: "Mover",
            copyStyles: "Copiar estilos",
            saveAsModule: "Salvar como modulo",
            addSectionAbove: "Adicionar secao acima",
            addSectionBelow: "Adicionar secao abaixo",
        },
        prompts: {
            copyHtml: "Copiar HTML",
            linkUrl: "URL do link",
            confirmDeleteAsset: "Excluir? Essa ação não pode ser desfeita.",
            sendTestEmail: "Enviar teste para qual e-mail?",
        },
        errors: {
            renderHtmlFailed: "Falha ao renderizar o HTML",
        },
        notifications: {
            saveError: "Erro ao salvar.",
            generatingScreenshot: "Gerando screenshot...",
            savingTemplate: "Salvando template...",
            templateSavedGlobal: "Template global salvo!",
            templateSaved: "Template salvo!",
            selectRowToSaveModule: "Selecione uma linha para salvar como módulo.",
            generatingModuleScreenshot: "Gerando screenshot do módulo...",
            savingModule: "Salvando módulo...",
            moduleSavedGlobal: "Módulo global salvo!",
            moduleSaved: "Módulo salvo!",
            updated: "Atualizado!",
            deleted: "Excluído!",
            startBlank: "Começando em branco!",
            invalidTemplateNoDoc: "Template inválido (sem doc).",
            templateApplied: "Template aplicado!",
            invalidModuleNoRow: "Módulo inválido (sem row).",
            moduleInserted: "Módulo inserido!",
            saved: "Salvo!",
            invalidEmail: "E-mail inválido.",
            sendingTestEmail: "Enviando teste para {0}...",
            htmlCopied: "HTML copiado!",
            changeTemplateInDevelopment:
                "Funcionalidade de trocar template em desenvolvimento",
            stylePasteBlockHint:
                "Agora clique em outro bloco do mesmo tipo para colar os estilos.",
            stylePasteRowHint: "Agora clique em outra linha para colar os estilos.",
            stylePasteSectionHint:
                "Agora clique em outra seção para colar os estilos.",
            stylePasteColumnHint:
                "Agora clique em outra coluna para colar os estilos.",
            duplicateColumnHint: "Agora clique em outra coluna para duplicar aqui.",
            stylesPasted: "Estilos colados!",
            columnDuplicated: "Coluna duplicada!",
            styleCopyCancelled: "Cópia de estilos cancelada.",
            applyingAi: "Aplicando alterações com IA...",
            emailUpdated: "Email atualizado!",
            aiApplyError: "Erro ao aplicar alterações com IA.",
        },
        palette: {
            blocks: {
                text: "Texto",
                image: "Imagem",
                button: "Botão",
                divider: "Divisor",
                spacer: "Espaçador",
            },
            rows: {
                oneColumn: "Linha: 1 coluna",
                twoColumns: "Linha: 2 colunas",
                threeColumns: "Linha: 3 colunas",
            },
        },
        tiptap: {
            font: "Fonte",
            bodyFont: "(Body font)",
            fontHelvetica: "Helvetica",
            fontArial: "Arial",
            fontGeorgia: "Georgia",
            fontTimes: "Times",
            lineHeight: "Line height",
            lineHeightShort: "LH",
            textColor: "Cor do texto",
            textBackground: "Fundo do texto",
            textGlyph: "A",
            removeBackground: "Remover fundo",
            bold: "Negrito",
            italic: "Itálico",
            underline: "Sublinhado",
            strike: "Riscado",
            snippets: "Snippets",
            size: "Tamanho",
            link: {
                title: "Text Link",
                close: "Fechar",
                linkTo: "Link para",
                type: {
                    web: "Web",
                    email: "Email",
                    whatsapp: "WhatsApp",
                    phone: "Telefone",
                    unsubscribe: "Descadastro",
                },
                web: {
                    url: "URL",
                    placeholder: "Digite a URL aqui",
                    invalid:
                        "Informe uma URL começando com http:// ou https://",
                },
                email: {
                    address: "Email",
                    placeholder: "email@empresa.com",
                    subject: "Assunto da mensagem",
                    body: "Corpo da mensagem",
                },
                whatsapp: {
                    phone: "Telefone (com DDD)",
                    phonePlaceholder: "(##) #####-####",
                    message: "Mensagem",
                },
                phone: {
                    number: "Telefone",
                    placeholder: "(##) #####-####",
                },
                unsubscribeHint:
                    "Este link será substituído automaticamente no envio do e-mail.",
                save: "Salvar",
                remove: "Remover",
            },
        },
    },
};
